import { GetStaticPaths, GetStaticProps, NextPage } from "next"
import React from "react"
import { SEO } from "components/core/seo"
import { PageModal } from "components/core/modal/pageModal"
import { selectPublicWidgets } from "repository/widget"
import { Widget } from "domainModels/widget"
import { dehydrate, QueryClient } from "react-query"
import { getPublicWidgetsKey } from "reactQuery/widget"
import { BASE_URL } from "lib/utils"

interface Props {
  widget: Widget
}

const WidgetPage: NextPage<Props> = ({ widget, children }) => (
  <>
    <SEO
      title={widget.information.name}
      description={widget.information.description ?? ""}
      ogImage={{
        title: widget.information.name,
        url: `${BASE_URL}/widget/${widget.information.slug}`,
      }}
    />
    <PageModal widget={widget} />
    {children}
  </>
)

export const getStaticPaths: GetStaticPaths = async () => {
  const publicWidgets = await selectPublicWidgets()

  return {
    paths:
      publicWidgets
        ?.filter((w) => !w.information.external_url)
        .map((widget) => ({
          params: { slug: widget.information.slug! },
        })) ?? [],
    fallback: false,
  }
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const slug = params?.slug?.toString()
  const queryClient = new QueryClient()
  const publicWidgets = await queryClient.fetchQuery(getPublicWidgetsKey(), selectPublicWidgets)
  const widget = publicWidgets?.find((w) => w.information.slug === slug)

  if (!widget) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      widget: JSON.parse(JSON.stringify(widget)),
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
    },
  }
}

export default WidgetPage
